import React from "react";

const paras_anbhule = () => {
  return (
    <div>
      <h1>Paras Anbhule</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Students of CS branch and having CGPA >= 7.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        First Day test then next day interview process of shortlisted students
        at 8am.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        MCQ questions + 2 coding questions (1 easy and 1 medium)
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        Around 15.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The interview was next day after the test. I focused on gaining
        information on the company and going through my project.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        2 rounds - 1st technical round (2-3 panel groups parallely) and 1 HR
        round.
        <br />
        Technical round - Questions were asked on project, DSA, a bit of
        networking and DBMS. Around 15-20 mins in this round.
        <br />
        HR round - asked about introducing myself, why choose bp, and future
        plans, etc. This round was easy and informal, around 5-10 mins for me.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        For me first simple questions on DSA, then on project, simple question
        on networking and a question on DBMS. (Focus more on project and DSA).
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        LeetCode.
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Fairly simple questions, both of them for me, but you can practice on
        LeetCode.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        For my round mostly questions were asked on the project. No questions
        about clubs or extracurricular activities. You can mention them during
        the HR round.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Learn more about the company's work and interests. Ask for feedback
        after interviews.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Submit the aptitude round quickly and correctly. Start DSA early.
        Prepare a good project. Smile during interviews and be confident (don’t
        space out or pause). All the best.
      </p>
    </div>
  );
};

export default paras_anbhule;
